if (!customElements.get('essential-addons')) {
  class EssentialAddons extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;

      this.initialized = true;
      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));

      if (this.tabs.length < 2) return;

      this.handleClick = this.handleClick.bind(this);
      this.handleKeydown = this.handleKeydown.bind(this);

      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', this.handleClick);
        tab.addEventListener('keydown', this.handleKeydown);
        tab.setAttribute('tabindex', index === 0 ? '0' : '-1');
      });

      this.activateTab(this.tabs[0], false);
    }

    disconnectedCallback() {
      if (!this.tabs) return;

      this.tabs.forEach((tab) => {
        tab.removeEventListener('click', this.handleClick);
        tab.removeEventListener('keydown', this.handleKeydown);
      });

      this.initialized = false;
    }

    handleClick(event) {
      this.activateTab(event.currentTarget);
    }

    handleKeydown(event) {
      const currentIndex = this.tabs.indexOf(event.currentTarget);
      let nextIndex = currentIndex;

      if (event.key === 'ArrowRight') {
        nextIndex = currentIndex + 1 >= this.tabs.length ? 0 : currentIndex + 1;
      } else if (event.key === 'ArrowLeft') {
        nextIndex = currentIndex - 1 < 0 ? this.tabs.length - 1 : currentIndex - 1;
      } else if (event.key === 'Home') {
        nextIndex = 0;
      } else if (event.key === 'End') {
        nextIndex = this.tabs.length - 1;
      } else {
        return;
      }

      event.preventDefault();
      this.activateTab(this.tabs[nextIndex]);
      this.tabs[nextIndex].focus();
    }

    activateTab(activeTab, announceChange = true) {
      const activePanelId = activeTab.getAttribute('aria-controls');

      this.tabs.forEach((tab) => {
        const isActive = tab === activeTab;
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
        tab.setAttribute('tabindex', isActive ? '0' : '-1');
      });

      this.panels.forEach((panel) => {
        panel.hidden = panel.id !== activePanelId;
      });

      if (announceChange) {
        window.dispatchEvent(new CustomEvent('on:breakpoint-change'));
      }
    }
  }

  customElements.define('essential-addons', EssentialAddons);
}
